import React, { memo, useCallback } from 'react';
import { connect } from 'react-redux';
import SliderListItem from '../../../../../../list-items/SliderListItem/SliderListItem';
import { createActions } from '../../../../store';

const WaveLayerPointRadius = memo(({ index, pointRadius, maxPointRadius, updateWaveLayerCustomOptions }) => {
    const onRadiusChange = useCallback(
        (value) => updateWaveLayerCustomOptions(index, "pointRadius", value),
        [index]
    );

    return (
        <SliderListItem
            title="Point Radius"
            value={pointRadius}
            displayMultiplier={100 / maxPointRadius}
            onValueChange={onRadiusChange}
            min={0}
            max={100}
            step={1}
        />
    );
});

const mapStateToProps = (state, { index }) => {
    const { pointRadius } = state.createPreview.present.videoSettings.visualizer.waveCircles[index].customOptions;
    const { maxPointRadius } = state.create.maxValues;

    return { pointRadius, maxPointRadius };
}

const mapDispatchToProps = (dispatch) => ({
    updateWaveLayerCustomOptions: (index, key, value) => dispatch(createActions.updateWaveLayerCustomOptions(index, key, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(WaveLayerPointRadius);
